import React, {useCallback, useEffect, useRef} from 'react';
import TrustPilot from '../../../../../../assets/images/logo_trustpilot.png'
import {useOnClickOutside} from "@amo/core/utils/hooks.js";
import {getTranslation} from "@amo/core/utils/index.js";
const TrustBox = ({ setShowPopin }) => {
    const ref = useRef(null);
    const contentRef = useRef(null);
    const dialogRef = useRef(null);
    useOnClickOutside(contentRef, () => setShowPopin(false))

    //todo ajouter le data-template-id et décommenter la ref et le useEffect pour afficher le trustpilot directement
    // Information dans le compte TrustPilot Business
    // https://support.trustpilot.com/hc/fr/articles/203840826-Ajouter-un-widget-TrustBox-pour-les-avis-marchands

    useEffect(() => {
        //if (window.Trustpilot) {
        //    window.Trustpilot.loadFromElement(ref.current, true);
        //}
    }, []);

    // Focus trap RGAA 7.3 / 12.8
    useEffect(() => {
        const modal = dialogRef.current;
        if (!modal) return;

        const previouslyFocused = document.activeElement;
        const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

        const handleKeyDown = (e) => {
            if (e.key !== 'Tab') return;
            const focusableElements = modal.querySelectorAll(focusableSelector);
            if (focusableElements.length === 0) return;
            const first = focusableElements[0];
            const last = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        modal.addEventListener('keydown', handleKeyDown);
        const focusable = modal.querySelectorAll(focusableSelector);
        if (focusable.length > 0) focusable[0].focus();

        return () => {
            modal.removeEventListener('keydown', handleKeyDown);
            if (previouslyFocused) previouslyFocused.focus();
        };
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Escape') {
            setShowPopin(false);
        }
    }, [setShowPopin]);

    return (
        <div className={"text-center"}>
            <div className={'modal-overlay position-fixed bottom-0 top-0 start-0 end-0 p-2'} onKeyDown={handleKeyDown} role="dialog" aria-modal="true" aria-label="Avis TrustPilot" ref={dialogRef}>
                <div className={'bg-white p-4 pb-5 mt-5 position-relative popin-content'} ref={contentRef}>
                    <img src={TrustPilot} alt="Trustpilot" width={300} loading="lazy"/>
                    <p className={'fw-bold my-4'}>{getTranslation('signature.trustPilot.tellUs')}</p>
                    <button type="button" className={'btn-close cursor-pointer position-absolute'} style={{top: 20, right: 20}} onClick={() => setShowPopin(false)} aria-label="Fermer" />

                    <a
                        //ref={ref}
                        href="https://fr.trustpilot.com/evaluate/april-moto.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={"btn btn-primary"}
                        onClick={() => setShowPopin(false)}
                    > {getTranslation("signature.trustPilot.evaluateMyExperience")} <span className="visually-hidden"> (nouvelle fenêtre)</span></a>
                </div>
            </div>
        </div>
    );
};
export default TrustBox;